import { submitInternalEvent as c } from "@ado/tracking-library";
import { useNavigationEventBus as E } from "@ado/acs-standard-library";
import { TRACKING_EVENTS as l } from "../../../shared/data/tracking/types/index.js";
import { getConfig as T } from "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { setIsQuebecFrench as t, setShowPolicyDialog as o } from "../../../shared/data/layout/state/index.js";
import { PolicyDialogType as i } from "../../../shared/data/layout/state/index4.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { defineComponent as d, computed as a } from "vue";
import { useBaseApplicationTranslation as v } from "../../../shared/libraries/local-translations/index.js";
const M = d({
  name: "DisclaimerDesktop",
  props: {
    settings: {
      type: Object,
      required: !0
    },
    isSimpleStyle: {
      type: Boolean,
      default: !1
    },
    showDefault: {
      type: Boolean,
      default: !0
    },
    isQuebec: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const f = E(), m = a(
      () => e.settings.countryCode === "GB" || e.settings.countryCode === "IE"
    ), r = a(() => !e.showDefault && e.isQuebec ? "en.footer" : "footer"), y = a(() => T().values), g = a(() => {
      const s = u(`${r.value}.all-rights-reserved`);
      return e.settings.footerCopyrightTextFormat.replace(
        "<currentYear>",
        String(new Date().getFullYear())
      ).replace("All Rights Reserved", s);
    }), h = async () => {
      e.isQuebec && t(e.showDefault), o(!0, i.PrivacyPolicy), c(l.FOOTER_PRIVACY_POLICY_CLICK);
    }, D = async () => {
      e.isQuebec && t(e.showDefault), o(!0, i.Disclaimer), c(l.FOOTER_DISCLAIMER_CLICK);
    }, C = async () => {
      e.isQuebec && t(e.showDefault), o(!0, i.Terms), c(l.FOOTER_TERMS_OF_USE_CLICK);
    }, w = async () => {
      e.isQuebec && t(e.showDefault), o(!0, i.CookiePolicy);
    }, P = async () => {
      e.isQuebec && t(e.showDefault), o(!0, i.EditorialPolicy);
    }, { t: u } = v();
    return {
      navigationEventBus: f,
      showCookiePolicyLink: m,
      footerCopyrightText: g,
      showTermsOfUseDialog: C,
      showDisclaimerDialog: D,
      showCookiePolicyDialog: w,
      showPrivacyPolicyDialog: h,
      showEditorialPolicyDialog: P,
      t: u,
      footerKey: r,
      getKeyPath: (s) => {
        let n = s;
        return r.value !== "footer" && (n = s.replace("footer", r.value)), n;
      },
      config: y
    };
  }
});
export {
  M as default
};
//# sourceMappingURL=index34.js.map
